import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-future-app-page',
  templateUrl: './future-app-page.component.html',
  styleUrls: ['./future-app-page.component.scss']
})
export class FutureAppPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
